import { useContext, useState } from 'react'
import { CUSTOMER_NOMINEE_FORM_CONFIG, ICustomerNominee } from '../../Models/Customer';
import { CustomerContext } from '../../contexts/CustomerContext';
import { NotificationContext } from '../../contexts/NotificationContext';
import DynamicForm, { useDynamicForm } from '../forms/DynamicFormNew';
import Title from '../custom/Title';


const CustomerNominee = ({submit}:{submit:Function}) => {
    const { setCustomerNominee, customerNominee, customerConfig } = useContext(CustomerContext)
    const { notify } = useContext(NotificationContext)

    const getFormConfig = () => CUSTOMER_NOMINEE_FORM_CONFIG.map(field => ({ ...field, value: customerNominee[field.fieldName as keyof ICustomerNominee] }))

    const { registerForm, setFormData} = useDynamicForm({
        formConfig: getFormConfig()
    })

    const submitHandler = (data: ICustomerNominee): any => {
        const nominee: ICustomerNominee = customerConfig.customerRefNo ? { ...data, dgCustomerRefNo: customerConfig.customerRefNo } : data 
        setCustomerNominee(nominee)
        submit()
    }



    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm onSubmit={submitHandler} submitText='Submit' {...registerForm()} />
            </div>
        </div>
    )
}

export default CustomerNominee